import script from "./EntrepostoAduaneiroCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./EntrepostoAduaneiroCadastro.vue?vue&type=script&setup=true&lang=js"

import "./EntrepostoAduaneiroCadastro.vue?vue&type=style&index=0&id=e8bb29cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8bb29cc"]])

export default __exports__